import { render, staticRenderFns } from "./CCMSocialDeterminantsEdit.vue?vue&type=template&id=482ee71c"
import script from "./CCMSocialDeterminantsEdit.vue?vue&type=script&lang=js"
export * from "./CCMSocialDeterminantsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports